import { api } from './client'

export interface Pnl {
  venituri: number
  costMP: number
  costConversie: number
  marjaBruta: number
  cheltuieliOperationale: number
  ebitda: number
  amortizare: number
  ebit: number
  cheltuieliFinanciare: number
  profitBrut: number
  impozit: number
  profitNet: number
}

export interface KpiSet {
  ca: number
  marjaBrutaPercent: number
  ebitda: number
  cashFlowOperational: number
  soldCreante: number
  soldDatorii: number
  valoareStoc: number
  rotatieStoc: number
  oeeQuality: number | null
  oeeAvailability: number | null
  otifPercent: number | null
  nrComenzi: number
  rataRebuturi: number
  dso: number
  dpo: number
}

export interface KpiReport {
  from: string
  to: string
  pnl: Pnl
  kpi: KpiSet
}

export const getKpiReport = (from: string, to: string) =>
  api.get<KpiReport>('/planificare/kpi', { params: { from, to } }).then((r) => r.data)
